import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FIREBASE_EVENTS, NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { Button } from 'components'
import { setDrawer, setStage } from 'slices/drawer'
import { getMassiveMessage } from 'utils'
import { useFirebaseEvent } from 'hooks'
import { STATICS } from 'statics'
import './style.scss'

export function MassiveWarning() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const { virtualSupportMassive } = useSelector(({ massive }) => massive)

  useEffect(() => {
    sendEvent(FIREBASE_EVENTS.VIRTUAL_SUPPORT_LOCATION_WITH_MASSIVE)
  }, [sendEvent])

  function handleClose() {
    dispatch(setDrawer(''))
  }

  function handleContinue() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.SIGNAL_VERIFY))
  }

  function renderSupportButton() {
    const { isMassive } = virtualSupportMassive

    if (isMassive)
      return (
        <Button className='button' color='primary' size='large' onClick={handleClose}>
          Ok, entendi!
        </Button>
      )

    return (
      <Button className='button' color='primary' size='large' onClick={handleContinue}>
        Preciso de ajuda
      </Button>
    )
  }

  function renderMassiveWarning() {
    const { description } = getMassiveMessage(virtualSupportMassive)

    return <p className='text'>{description}</p>
  }

  function renderButtons() {
    return <div className='links'>{renderSupportButton()}</div>
  }

  return (
    <div className='virtual-support-info'>
      <STATICS.INFO_CICLE_MASSIVE className='icon' />
      {renderMassiveWarning()}
      {renderButtons()}
    </div>
  )
}
